import React, { useState, useRef } from 'react';
import { ButtonHeading } from 'components';
import { constant } from 'constants/constant';
import Tab from 'components/common/Tab';
import UnitDetailsTab from 'components/MastersDetailsTabs/UnitDetailsTabs/UnitDetailsTab';
import LoadingBar from 'react-top-loading-bar';
import useDocumentTitle from 'hooks/useDocumentTitle';
import { useNavigate } from 'react-router-dom';
import SupplierSettingsTab from 'components/MastersDetailsTabs/SupplierSettingsTab/SupplierSettingsTab';

const AddressBookDetails = () => {
    useDocumentTitle("AddressBook Details | T360");

    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState(1);
    const [detailsData, setDetailsData] = useState({});
    const loadingBarRef = useRef(null); // Create a ref for the loading bar

    const handleDetailsData = (data) => {
        setDetailsData(data);
    };

    const tabProps = {
        tabList: constant.addressBokkDetailsTabs,
        callBackTab: (e) => setActiveTab(e),
        activeTab: activeTab
    };

    return (
        <div className=''>
            <LoadingBar
                color="#ffa800"
                ref={loadingBarRef}
                height={4}
                loaderSpeed={1000}
                shadow={true}
            />
            <ButtonHeading
                title='Address Book'
                buttonTitle="Back"
                isBackButton={true}
                onClickBackButton={() => navigate(-1)}
            />

            <div className='addPr_flBx'>
                <Tab {...tabProps} />
                {activeTab === 1 && <SupplierSettingsTab name='addressBook'/>}
            </div>
        </div>
    );
}

export default AddressBookDetails